<template>
    <div class="cart-item-option">
        <div class="cart-item-option-details">
            <div class="cart-item-option-name">
                <div class="quantity" v-if="option.quantity > 1">{{ option.quantity }}x</div>
                {{ getNameInLocationLanguage(option, props.showInternalNames) }}<ItemIcons :articleId="option.articleId" />
            </div>
            <div class="cart-item-option-price">
                <CartItemPrice
                    v-if="option.unitPrice != 0"
                    class="cart-item-option-price"
                    :item="option"
                    :quantity="nextMultiplier"
                    @click="onPriceClick"
                />
            </div>
        </div>
        <div class="subs" v-if="option.options.length">
            <CartItemOptionGroup
                v-for="optionGroup in option.options"
                :key="optionGroup.id"
                :optionGroup="optionGroup"
                :multiplier="nextMultiplier"
                :showInternalNames="props.showInternalNames"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { ICartItem } from "@/data/model/Customer";
    import { useCartStore } from "@/data/stores/cart";
    import { getNameInLocationLanguage } from "@/shared/helpers/ItemNameHelper";
    import { computed } from "vue";

    import ItemIcons from "@/components/order/ItemIcons.vue";

    import CartItemOptionGroup from "./CartItemOptionGroup.vue";
    import CartItemPrice from "./CartItemPrice.vue";

    const cart = useCartStore();

    // define properties
    const props = defineProps<{
        option: ICartItem;
        multiplier: number;
        showInternalNames: boolean;
    }>();

    // define computed
    const nextMultiplier = computed(() => props.multiplier * props.option.quantity);

    // define functions
    function onPriceClick() {
        if (!props.option.hasDiscount) {
            return;
        }

        cart.showConfirmItemDiscountsRemovalPopup(props.option);
    }
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../assets/styles/scss/shared/_variables.scss";

    .cart-item-option {
        font-size: 12px;
        line-height: 1.666em;

        > .cart-item-option-details {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;

            > .cart-item-option-name {
                > .quantity {
                    display: inline-block;
                    vertical-align: top;
                    padding-right: 0.25em;
                    font-weight: 600;
                }

                flex-grow: 1;
            }

            > .cart-item-option-price {
                flex: 0 0 4.666em;
                padding-right: 1.666em;

                > .has-discount {
                    cursor: pointer;
                    transition: opacity 0.2s variables.$easeOutExpo;

                    &:hover {
                        opacity: 0.5;
                    }
                }
            }
        }
        > .subs {
            padding: 0.1666em 0;
            padding-left: 1em;
        }
    }
</style>
